/**
 * The three reassurance points that sit under the hero headline.
 *
 * Deliberately claims about how the company works rather than credentials or
 * counts. The brief is firm that only verifiable claims may appear, and
 * licence numbers, accreditations and job totals are not confirmed yet — those
 * belong in the trust bar once the business supplies them.
 */
import { UserCheck, Leaf, Star } from "lucide-react";

const FEATURES = [
  { icon: UserCheck, label: "Experienced\nTeam" },
  { icon: Leaf, label: "Safe & Eco\nFriendly" },
  { icon: Star, label: "Satisfaction\nGuaranteed" },
];

export default function HeroFeatures({ className = "" }) {
  return (
    <div
      className={`flex flex-wrap items-center gap-x-6 gap-y-4 ${className}`}
      data-testid="hero-features"
    >
      {FEATURES.map((feature, index) => {
        const Icon = feature.icon;
        return (
          <div key={feature.label} className="flex items-center gap-3">
            {index > 0 && (
              <span className="hidden sm:block h-8 w-px bg-charcoal -ml-3 mr-3" aria-hidden="true" />
            )}
            <Icon className="w-6 h-6 text-emerald shrink-0" aria-hidden="true" />
            <span className="text-xs md:text-[13px] text-white/85 leading-tight whitespace-pre-line">
              {feature.label}
            </span>
          </div>
        );
      })}
    </div>
  );
}
